import { Injectable } from '@angular/core';
import { ExportExcelModel } from '../export-excel/export-excel.model';
import { HttpClient } from '@angular/common/http';
import { FormGeneratorService, BaseModel } from '@ngx-resource-toolkit/core';
import { ToasterService } from 'angular2-toaster';
import { SettingsService } from '../../core/settings/settings.service';
import { saveAs } from 'file-saver';
import { environment } from '../../../environments/environment';
import { ParametreModel } from '../../parametrage/listes/parametres/parametre.model';
import { Observable } from 'rxjs';


@Injectable()
export class ExportService {
    private pdf_export_file: boolean = false;
    constructor(
        private settings: SettingsService,
        private toaster: ToasterService,
        private http: HttpClient,
        private formGenerator: FormGeneratorService) {
        new ParametreModel().getResource('default', 'get').call(this.http, 'getParametreObject', ['EXPORT', 'PDF'])
            .subscribe(data => {
                this.pdf_export_file = (data && data.valeur == 'file');
            })
    }

    isViewable(type) {
        console.log(type);
        return type && (type.includes('application/pdf') || type.includes('image'));
    }
    /**
     * Ouvre une PJ d'un courriel
     */
    openFilePJ(idFile, filename) {
        const excelModel = new ExportExcelModel(null, null, idFile);
        excelModel.getResource('default', 'post')
                    .call(this.http, 'getFilePJ.php', this.formGenerator.createFormGroup(excelModel, 'create'), [], {
                        responseType: 'blob',
                        observe: 'response'
                    })
            .subscribe((res: any) => {
                const typeMime = res.headers.get('Content-Type');
                const blob = new Blob([res.body], { type: typeMime });
                console.log({blob, res, typeMime});
                if (this.isViewable(typeMime)) {
                    this.openInBrowser(res.body, typeMime, `${filename}`);
                } else {
                    saveAs(blob, `${filename}`);
                }
            }, (err) => {
                console.log('openPJFile error', err);
                this.toaster.pop('error', `Erreur lors du téléchargement du fichier`);
            });
    }
    /**
     * Ouvre une PJ d'un courriel
     */
    openFile(filenameOnDisk, filename) {
        const excelModel = new ExportExcelModel(filenameOnDisk, filename);
        excelModel.getResource('default', 'post')
                    .call(this.http, 'getFichier.php', this.formGenerator.createFormGroup(excelModel, 'create'), [], {
                        responseType: 'blob',
                        observe: 'response'
                    })
            .subscribe((res: any) => {
                const typeMime = res.headers.get('Content-Type');
                const blob = new Blob([res.body], { type: typeMime });
                if (this.isViewable(typeMime)) {
                    this.openInBrowser(res.body, typeMime, `${filename}`);
                } else {
                    saveAs(blob, `${filename}`);
                }
            }, (err) => {
                console.log('openPJFile error', err);
                this.toaster.pop('error', `Erreur lors du téléchargement du fichier`);
            });
    }

    exportPrint(model: BaseModel, method: string, filenameOnDisk: string, params: any[] = []) {

        model.getResource('default', 'get')
            .call(this.http, method, params)
            .flatMap((filename: string) => {
                const excelModel = new ExportExcelModel(filename, filenameOnDisk);
                return excelModel.getResource('default', 'post')
                    .call(this.http, 'getExportExcel.php', this.formGenerator.createFormGroup(excelModel, 'create'), [], {
                        responseType: 'blob',
                        observe: 'response'
                    });
            })
            .subscribe((res: any) => {

                const blob = new Blob([res.body], { type: res.headers.get('Content-Type') });
                saveAs(blob, `${filenameOnDisk}.pdf`);

            }, (err) => {
                console.log('ExportService', 'exportPrint error', err);
                this.toaster.pop('error', `Erreur lors de l\'impression ${method}`);
            });


    }

    /** Génère un export Excel
     * searchModel : sert à déterminer le service à utiliser côté serveur
     * searchFormValue : Critères de recherche
     * method : méthode à appeler côté serveur
     * filenameOnDisk : nom du fichier à enregistrer
     * params : paramètres complémentaires en fonction de ce qui est demandé par le service
     * paramsComplet : si renseigné, ignore tous les autres paramètres et utilise ce tableau de aramètres
    */
    exportWrapper(searchModel: BaseModel, searchFormValue: any, method: string, filenameOnDisk: string, params?: Array<any>,
        paramsComplet?: Array<any>, callback?: any, compopnent?: any) {
        console.log('exportWrapper', searchModel, searchFormValue, method, filenameOnDisk, params, paramsComplet);
        if (paramsComplet) {
            params = paramsComplet;
        } else {
            const paramComplement = [searchFormValue, this.settings.getUserSetting('anneeScolaire')];
            params = params ? paramComplement.concat(params) : paramComplement;
        }
        console.log('exportWrapper params final', params);
        searchModel
            .getResource('default', 'get')
            .call(this.http, method, params)
            .flatMap((filename: string) => {
                console.log('exportWrapper fichier prêt à récupérer', filename);
                const excelModel = new ExportExcelModel(filename, filenameOnDisk);
                return excelModel.getResource('default', 'post')
                    .call(this.http, 'getExportExcel.php', this.formGenerator.createFormGroup(excelModel, 'create'), [], {
                        responseType: 'blob',
                        observe: 'response'
                    });
            })
            .subscribe((res: any) => {
                console.log({ filenameOnDisk, type: res.headers.get('Content-Type'), header: res.headers });
                const blob = new Blob([res.body], { type: res.headers.get('Content-Type') });
                // Voir s'il n'existe pas une API qui fait la conversion de nombreux types connus
                let extension = 'xlsx';
                switch (res.headers.get('Content-Type')) {
                    case 'text/csv': {
                        extension = 'csv';
                        break;
                    }
                    case 'application/vnd.ms-excel': {
                        extension = 'xls';
                        break;
                    }
                    default: {
                        extension = 'xlsx';
                    }
                }
                saveAs(blob, `${filenameOnDisk}.${extension}`);

            }, (err) => {
                console.log('ExportService', 'export error', err);
                this.toaster.pop('error', `Erreur lors de l\'export ${method}`);
                if (callback) {
                    if (compopnent) {
                        callback(compopnent);
                    } else {
                        callback();
                    }
                }
            }, () => {
                // console.log('export terminé');
                this.toaster.pop('info', `L\'export du fichier ${filenameOnDisk} est terminé`);
                if (callback) {
                    if (compopnent) {
                        callback(compopnent);
                    } else {
                        callback();
                    }
                }
            });
    }

    openInBrowser(data: any, typeMime: string = 'application/pdf', file_name: string = 'nomDuFichier') {
        const blob = new Blob([data], { type: typeMime });
        if (typeMime == 'application/pdf' && this.pdf_export_file) {
            // Enregistrement du fichier avec un nom explicite
            saveAs(blob, file_name);
        } else {
            // Ouverture dans le navigateur
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                console.log('cas 1 : window.navigator.msSaveOrOpenBlob');
                window.navigator.msSaveOrOpenBlob(blob, file_name);
            } else {
                console.log('cas 2 : window.open');
                const blobURL = URL.createObjectURL(blob);
                window.open(blobURL, '_blank');
            }
        }
    }

    onlyGeneratePdf(searchModel: BaseModel, params: Array<any>, method: string, filenameOnDisk: string): Observable<any> {
        return searchModel
            .getResource('default', 'get')
            .call(this.http, method, params)
            .flatMap((filename: string) => {
                const excelModel = new ExportExcelModel(filename, filenameOnDisk);
                return excelModel.getResource('default', 'post')
                    .call(this.http, 'getExportExcel.php', this.formGenerator.createFormGroup(excelModel, 'create'), [], {
                        responseType: 'blob',
                        observe: 'response'
                    });
            })
    }
    generePDF(searchModel: BaseModel, params: Array<any>, method: string, filenameOnDisk: string, callback?: any, compopnent?: any) {
        console.log('searchModel: BaseModel, params: Array<any>, method: string, filenameOnDisk: string',
            searchModel, params, method, filenameOnDisk);
        this.onlyGeneratePdf(searchModel, params, method, filenameOnDisk)
        /*searchModel
            .getResource('default', 'get')
            .call(this.http, method, params)
            .flatMap((filename: string) => {
                const excelModel = new ExportExcelModel(filename, filenameOnDisk);
                return excelModel.getResource('default', 'post')
                    .call(this.http, 'getExportExcel.php', this.formGenerator.createFormGroup(excelModel, 'create'), [], {
                        responseType: 'blob',
                        observe: 'response'
                    });
            })*/
            .subscribe((res: any) => {
                console.log({ ou: 'generePDF', typeMime: res.headers.get('Content-Type'), filenameOnDisk});
                this.openInBrowser(res.body, 'application/pdf', `${filenameOnDisk}.pdf`);
            }, (err) => {
                console.log('ExportService', 'export error', err);
                this.toaster.pop('error', `Erreur lors de l\'export ${method}`);
                if (callback) {
                    if (compopnent) {
                        callback(compopnent);
                    } else {
                        callback();
                    }
                }
            }, () => {
                if (callback) {
                    if (compopnent) {
                        callback(compopnent);
                    } else {
                        callback();
                    }
                }
            });
    }

    /**
     * Génère un PDF en utilisant le service php ServiceImpression
     * @param searchModel
     * @param params
     * @param method
     * @param filenameOnDisk
     */
    generePDF2(service: string, method: string, params: Array<any>, filenameOnDisk: string) {
        console.log('generePDF2', service, method, params, filenameOnDisk, this.http);
        this.http.get(environment.proxyUrl + '/' + service + '/' + method,
            {
                params: {
                    'params': JSON.stringify(params),
                }
            }
        ).flatMap((filename: string) => {
            const excelModel = new ExportExcelModel(filename, filenameOnDisk);
            return excelModel.getResource('default', 'post').call(
                this.http, 'getExportExcel.php', this.formGenerator.createFormGroup(excelModel, 'create'),
                [], {
                    responseType: 'blob',
                    observe: 'response'
                }
            );
        })
            .subscribe(
                (res: any) => {
                    console.log('res=', res);
                    // const blob = new Blob([res.body], { type: res.headers.get('Content-Type') });
                    // saveAs(blob, `${filenameOnDisk}.pdf`);
                    console.log({ ou: 'generePDF2', typeMime: res.headers.get('Content-Type'), filenameOnDisk });
                    this.openInBrowser(res.body, 'application/pdf', `${filenameOnDisk}.pdf`);

                }, (err) => {
                    console.log('ExportService', 'export error', err);
                    this.toaster.pop('error', `Erreur lors de l\'export ${method}`);
                }
            );
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/services/export.service.ts